import React, { useEffect } from 'react';
import '../styles/Career.css';

const CareerHero = () => {
  useEffect(() => {
    const heroContent = document.querySelector('.career-hero-content');
    setTimeout(() => {
      heroContent.style.opacity = '1';
      heroContent.style.transform = 'translateY(0)';
    }, 300);
  }, []);

  return (
    <section className="career-hero">
      <div className="career-hero-content">
        <h1>Build Your Career in Pharmaceutical Innovation</h1>
        <p>Join our passionate team dedicated to advancing women's healthcare through cutting-edge research and development.</p>
        {/* <div className="btn-group">
          <a href="#openings" className="btn">View Open Positions</a>
          <a href="#why-join" className="btn btn-outline">Why Join Us?</a>
        </div> */}
      </div>
    </section>
  );
};

export default CareerHero;